import { render, staticRenderFns } from "./WorkIconContainer.vue?vue&type=template&id=98c49244"
import script from "./WorkIconContainer.vue?vue&type=script&lang=js"
export * from "./WorkIconContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports